import { autoinject, computedFrom } from "aurelia-framework";
import { RightShipInspectionDetailsModel } from "../../../../models/rightship-inspections.models";

@autoinject
export class PartialTooltipInspectionDetails {
    public inspectionModel: RightShipInspectionDetailsModel;
    public inspectionNumber: number;

    constructor() {
    }

    activate(params: { inspectionModel: RightShipInspectionDetailsModel }) {
        this.inspectionModel = params.inspectionModel;
        this.inspectionNumber = params.inspectionModel.rightShipInspectionId;
    }

    @computedFrom("inspectionModel")
    get vesselDetailsFields() {
        const fields = this.inspectionModel && this.inspectionModel.vesselDetails ? [
            {
                label: "Vessel",
                value: this.inspectionModel.vesselDetails.vesselName
            },
            {
                label: "IMO",
                value: this.inspectionModel.vesselDetails.vesselImo
            },
            {
                label: "Date of build",
                value: this.inspectionModel.vesselDetails.dateOfBuild
            },
            {
                label: "Vessel type",
                value: this.inspectionModel.vesselDetails.vesselType
            },
            {
                label: "DWT",
                value: this.inspectionModel.vesselDetails.dwt
            },
            {
                label: "Flag",
                value: this.inspectionModel.vesselDetails.flag
            }
        ]: [];
        return fields;
    }

    @computedFrom("inspectionModel")
    get portAndOperationalDetailsFields() {
        const fields = this.inspectionModel && this.inspectionModel.portAndOperationalDetails ? [
            {
                label: "Requested inspection date",
                value: this.inspectionModel.portAndOperationalDetails.requestedInspectionDate
            },
            {
                label: "Port",
                value: this.inspectionModel.portAndOperationalDetails.port
            },
            {
                label: "Country",
                value: this.inspectionModel.portAndOperationalDetails.country
            },
            {
                label: "Est. arrival date",
                value: this.inspectionModel.portAndOperationalDetails.estimatedArrivalDate
            },
            {
                label: "Length of time at berth",
                value: this.inspectionModel.portAndOperationalDetails.lengthOfTimeAtBerth
            },
            {
                label: "Cargo operation",
                value: this.inspectionModel.portAndOperationalDetails.cargoOperation
            }
        ]: [];
        return fields;
    }

    @computedFrom("inspectionModel")
    get agentDetailsFields() {
        const fields = this.inspectionModel && this.inspectionModel.agentDetails ? [
            {
                label: "Agent name",
                value: this.inspectionModel.agentDetails.agentName
            },
            {
                label: "Agent office number",
                value: this.inspectionModel.agentDetails.agentOfficeNumber
            },
            {
                label: "Agent email address",
                value: this.inspectionModel.agentDetails.agentEmailAddress
            }
        ]: [];
        return fields;
    }
}